<template>
  <v-app-bar elevation="0" class="global-header" :color="colors.white">
    <v-icon @click.stop="sideNav = !sideNav" class="hidden-sm-and-up"
      >mdi-bell-outlined</v-icon
    >
    <!-- Xift Logo -->
    <v-toolbar-title class="logo-container">
      <span
        @click="canClickXiftLogo && initalRoute('GO_TO_INITAL')"
        data-test-id="xift-logo"
        :class="canClickXiftLogo ? 'pointer' : ''"
      >
        <v-img
          :src="$images.XIFT_LOGO"
          class="my-3"
          contain
          width="63"
          height="40"
          aspect-ratio="1.1"
        />
      </span>
    </v-toolbar-title>
    <!-- Menu -->
    <v-btn
      tile
      class="main-menu global-btn px-0 mb-0 mr-5"
      text
      v-for="item in menuItems"
      :key="item.parent"
      :ripple="false"
      :to="item.path"
      :data-test-id="item.meta && item.meta.id"
    >
      {{ item.parent }}
    </v-btn>
    <v-spacer></v-spacer>
    <OnboardingProgressBar v-if="showOnboardingProgressBar" />
    <RhsMenu :showNotification="canShowNotification" parentDataTestId="global-nav"/>
  </v-app-bar>
</template>
<script>
import { mapState } from 'vuex';
import RhsMenu from '@/components/GlobalComponent/RhsMenu';
import OnboardingProgressBar from '@/components/GlobalComponent/OnboardingProgress/OnboardingProgressBar';
export default {
  components: {
    RhsMenu,
    OnboardingProgressBar
  },
  props: {
    dynamicItems: Array,
    canClickXiftLogo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      globalMenuItems: 'allPermissions'
    }),
    ...mapState([
      'globalNav',
      'isCurrentOrgLegacy',
      'orgId',
      'currentlySelectedOrgId',
      'onboardingStatus'
    ]),
    isSelectedOwnOrg() {
      return this.orgId === this.currentlySelectedOrgId;
    },
    isOnboarded() {
      return this.onboardingStatus === 'ONBOARDED';
    },
    canShowNotification() {
      return !this.dynamicItems;
    },
    showOnboardingProgressBar() {
      // to show onboardingProgressBar only to private admin of subscribed organisation
      // if its status is not onboarded
      return (
        this.$can('view', 'onboarding_progress') &&
        this.canShowNotification &&
        this.isSelectedOwnOrg &&
        !this.isOnboarded &&
        !this.isCurrentOrgLegacy
      );
    },
    currentPath() {
      return this.$route.path;
    },
    colors() {
      return this.$vuetify?.theme?.themes?.light;
    }
  },
  watch: {
    globalMenuItems(newVal) {
      this.renderMenuItems(newVal);
    },
    globalNav(newVal) {
      this.renderMenuItems(newVal);
    },
    currentPath() {
      this.renderMenuItems(this.globalNav);
    }
  },
  methods: {
    renderMenuItems(items) {
      if (this.dynamicItems) {
        this.menuItems = [];
        return;
      }
      this.menuItems = items;
    }
  },
  data() {
    return {
      sideNav: false,
      menuItems: []
    };
  },
  mounted() {
    this.renderMenuItems(this.globalNav);
  }
};
</script>
